/* Phần dùng chung giữa Submissions và Portfolio. */
import { Badge } from "@/components/ui/badge"
import { UserAvatar } from "@/components/page"

export const productStatusLabel: Record<string, string> = {
  draft: "Đang lưu tạm",
  trial_queued: "Đang chấm thử",
  trial_scored: "Đã chấm thử",
  final_queued: "Đang chấm thật",
  final_scored: "Đã chấm thật",
  failed: "Cần thử lại",
}

const statusVariant: Record<string, "default" | "secondary" | "success" | "warning" | "destructive" | "outline"> = {
  draft: "outline",
  trial_queued: "warning",
  trial_scored: "default",
  final_queued: "warning",
  final_scored: "success",
  failed: "destructive",
}

export function StatusBadge({ status }: { status: string }) {
  return <Badge variant={statusVariant[status] || "secondary"}>{productStatusLabel[status] || status}</Badge>
}

export function MeTag({ show }: { show?: boolean }) {
  return show ? <Badge variant="solid">Bạn</Badge> : null
}

/** Avatar tác giả; có slug → mở portfolio công khai trên www. */
export function SubmissionAvatar({ author, size }: { author: any; size?: "sm" | "default" | "lg" }) {
  const avatar = <UserAvatar user={author} size={size} />
  if (!author?.slug) return avatar
  return (
    <a
      href={`https://www.sutucon.com/portfolio/${author.slug}`}
      target="_blank"
      rel="noreferrer"
      title={`Xem portfolio của ${author.full_name}`}
      onClick={(e) => e.stopPropagation()}
      className="shrink-0 rounded-full"
    >
      {avatar}
    </a>
  )
}
